import { HttpClientService } from './http-client.service';
import { HelperService } from './helper.service';
import { Observable } from 'rxjs';
import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import * as moment from 'moment';
import {ReCaptchaV3Service} from "ng-recaptcha";

@Injectable({
    providedIn: 'root',
})
export class ReservationsService {
    constructor(private http: HttpClient, private httpClient: HttpClientService, private helper: HelperService, private recaptchaV3Service: ReCaptchaV3Service) {}

    getTokenInfo(token: string) {
        return this.http.get(this.getReservationsUlr('booking/info/' + token));
    }

    public getFreeSlotsWidget(
        apiKey: string,
        subcKey: string,
        serviceKey: string,
        from: moment.Moment,
        to: moment.Moment,
    ): Observable<any> {
        const fromS: string = from.format('YYYY-MM-DD');
        const toS: string = to.format('YYYY-MM-DD');
        return this.httpClient.get(
            this.helper.getPatientUrl(
                `freeslots/contractors/${apiKey}/subcontractors/${subcKey}/services/${serviceKey}?from=${fromS}&to=${toS}`,
            ),
        );
    }

    public getContractorServiceInfo(apiKey: string, serviceKey: string): Observable<any> {
        return this.httpClient.get(this.helper.getPatientUrl(`contractors/${apiKey}/services/${serviceKey}`));
    }

    public getFreeSlots(
        token: string,
        maskedContractorId: string,
        subcontractor: number,
        service: number,
        from: Date | moment.MomentInput,
        to: Date | moment.MomentInput,
    ) {
        const params = {
            maskedContractorId: maskedContractorId,
            contractor: {
                subcontractors: [
                    {
                        id: subcontractor,
                    },
                ],
            },
            service: {
                id: service,
            },
            from: moment(from).format('YYYY-MM-DD'),
            to: moment(to).format('YYYY-MM-DD'),
        };

        return this.http.post(this.getReservationsUlr('freeslots/' + token), params);
    }

    public getReservationsUlr(path?: string) {
        if (!path) {
            path = '';
        }
        return (
            environment.service.protocol +
            environment.service.rootUrl +
            environment.service.apiPort +
            environment.service.apiUrl +
            '/' +
            path
        );
    }
}
